import { render, staticRenderFns } from "./ModernTabButton.vue?vue&type=template&id=2da939db&scoped=true&"
import script from "./ModernTabButton.vue?vue&type=script&lang=js&"
export * from "./ModernTabButton.vue?vue&type=script&lang=js&"
import style0 from "./ModernTabButton.vue?vue&type=style&index=0&id=2da939db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da939db",
  null
  
)

export default component.exports